import type { RouteSectionProps } from "@solidjs/router";
import type { JSX } from "solid-js";
import { CheatSheetHost } from "./features/cheat-sheet/cheatSheet";
import { PaletteHost } from "./features/command-palette/palette";

export function AppRoot(props: RouteSectionProps): JSX.Element {
  return (
    <>
      {props.children}
      <PaletteHost />
      <CheatSheetHost />
    </>
  );
}
